import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components';
import Header_Container from '../components/Header_Container'
import img from '../assets/project2.png'
import movie_img from '../assets/showcase_movie-search.png'
import c3_img from '../assets/react-c3.png'

const Left = styled.div`
	flex:1;
	background: #f3c130;
	width:100%;
	height: 100%;

`
const Right = styled.div`
	flex: 1;
	width:100%;
	height: 100%;
	background: #f8f8f8;
`

const Title = styled.div`
	position: absolute;
	width: 30%;
	height: 40%;
	top: 30%;
	left:35%;
	display: flex;
	justify-content: center;
	align-items: center;
	h1{
		font-size: 8rem;
		font-weight: 700;
	}

`


const Project = styled.section`
	width:100%;
	min-height: 100vh;
	background: #f8f8f8;
	
`

const Project_Container = styled.div`
	width: 100%:
	height: 100%;
	position: relative;
`
const Project_Item = styled.a`
	width: 100%;
	display: flex;
	flex-direction: row-reverse; 
	color: #414a6b;
	&:hover{
		text-decoration: none;
		color: #414a6b;
		.project_title:after{
			width: 100%;
		}
	}



`
const Project_image = styled.div`
	flex: 1;
	height: 400px;
	background-position: center;
	background-size: cover
`

const Project_title = styled.div`

	flex: 1;
	display: flex;
	flex-flow: column;
	justify-content: center;
	align-items:center;
	div{
			text-align:left;
			margin-top: 10px;
	}

	h3{
		font-size: 32px; !important
	}
	span{
		margin-left: 20px;
		color: #6d6d6d;
	}
	
`



const SecondPage = () => (
  <div className="Wrapper">
	<div className="app">
			   		<div>
			   			<section className="intro">	
			   				<Right></Right>
			   					<Left></Left>
			   					
			   					<Title>
			   						<h1>PROJECT</h1>
			   					</Title>
			   				</section>
			   				<Project>
								<div className="fluid-container">
									<div className="row justify-content-center">
									<Project_Container className="col-md-12">
										<Project_Item href="http://prodigygod0209.github.io/movie-search-app/">
												<Project_image style = {{ backgroundImage: `url(${c3_img})` }}>
												</Project_image>
												<Project_title>
													<h3 className="project_title" style = {{ fontSize: "30px"}}>React C3 Maker</h3>
													<div>
													<span>Web App</span>
													<span>JavaScript</span>
													<span>React</span>		
													<span>C3</span>		
													<span>D3</span>
													</div>
												</Project_title>
										</Project_Item>
									</Project_Container>
										<Project_Container className="col-md-12">
											<Project_Item href="http://prodigygod0209.github.io/movie-search-app/">
													<Project_image style = {{ backgroundImage: `url(${movie_img})` }}>
													</Project_image>
													<Project_title>
														<h3 className="project_title" style = {{ fontSize: "30px"}}>Movie Search</h3>
														<div>
														<span>Web App</span>
														<span>JavaScript</span>
														<span>React</span>	
														<span>React-router</span>	
														<span>DMDB</span>		
														<span>AJAX</span>
														</div>
													</Project_title>
											</Project_Item>
										</Project_Container>
										<Project_Container className="col-md-12">
											<Project_Item href="https://github.com/prodigygod0209/react-gitcard">
													<Project_image style = {{ backgroundImage: `url(${img})` }}>
													</Project_image>
													<Project_title>
														<h3 className="project_title" style = {{ fontSize: "30px"}}>Git Card</h3>
														<div>
														<span>Web App</span>
														<span>JavaScript</span>
														<span>React</span>				
														</div>
													</Project_title>
											</Project_Item>
										</Project_Container>
									</div>
								</div>
			   				</Project>
			   		</div>
	</div>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/project.js